import React from 'react';
import { Project1 } from './Project1';
import { Project2 } from './Project2';
import { Project3 } from './Project3';
import { Project4 } from './Project4';
import { Project5 } from './Project5';
import { Project6 } from './Project6';

const Modal = ({setOpenModal, id}) => {

return (
      <> 
        <div 
          onClick={() => setOpenModal(false)} 
          data-aos="zoom-out"  data-aos-duration="1000"
          className="fixed inset-0 bg-black bg-opacity-25 backdrop-grayscale flex items-center justify-center z-50">
          <div 
            onClick={(e) => {e.stopPropagation()}}
            className="relative border rounded-md border-violet-500 w-[90%] xl:w-[900px] bg-white dark:bg-light-black " data-aos="zoom-in"  data-aos-duration="2000">
            <div 
              onClick={() => setOpenModal(false)}
              className="flex justify-end items-center cursor-pointer">
              <span className="absolute h-6 w-6 bg-rose-500  text-white text-center rounded-full -top-3 -right-[11px] z-20">x</span>
            </div>
            <div className='relative h-[90vh] sm:h-[auto] overflow-y-scroll scrollbar-hide'>

              {/*--- Projects ---*/}
              <div className='relative'>
                {id ===1 && <Project1 />}
                {id ===2 && <Project2 />}
                {id ===3 && <Project3 />}
                {id ===4 && <Project4 />}
                {id ===5 && <Project5 />}
                {id ===6 && <Project6 />}
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default Modal;